import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'

export const getEmailVideoList = (model) => {
  let data = convertPageModel(model);
  return postData("/EmailVideo/GetEmailVideoList", data);
}

export const getEmailVideo = (id) => {
  return getData(`/EmailVideo/GetEmailVideo/${id}`);
}

export const isEmailVideoTitleExist = (courseId, title, id = null) => {
  let data = {
    courseId,
    title,
    id
  };
  return getData("/EmailVideo/IsEmailVideoTitleExist", data);
};

export const saveEmailVideo = (data) => {
  return postData("/EmailVideo/SaveEmailVideo", data);
}

export const resendEmailVideo = (id, studentIds) => {
  let data = studentIds;
  return postData(`/EmailVideo/ResendEmailVideo/${id}`, data);
}

export const getEmailVideoTeachers = () => {
  return getData(`/EmailVideo/GetEmailVideoTeachers`);
}



// WEBPACK FOOTER //
// ./src/service/emailVideo.service.js